const API_BASE_URL = "https://njengo-server-1.onrender.com/api";

export const endpoints = {
  auth: {
    login: `${API_BASE_URL}/auth/login`,
    me: `${API_BASE_URL}/auth/me`,
    register: `${API_BASE_URL}/auth/register`,
    refresh: `${API_BASE_URL}/auth/refresh`,
    users: `${API_BASE_URL}/auth/users`,
    user: (id: string) => `${API_BASE_URL}/auth/users/${id}`,
    bulkDeleteUsers: `${API_BASE_URL}/auth/users/bulk-delete`,
  },
  users: {
    suspend: (id: string) => `${API_BASE_URL}/users/${id}/suspend`,
    unsuspend: (id: string) => `${API_BASE_URL}/users/${id}/unsuspend`,
  },
  suppliers: {
    list: `${API_BASE_URL}/suppliers`,
    create: `${API_BASE_URL}/suppliers`,
    update: (id: string) => `${API_BASE_URL}/suppliers/${id}`,
    delete: (id: string) => `${API_BASE_URL}/suppliers/${id}`,
    bulkDelete: `${API_BASE_URL}/suppliers/bulk-delete`,
  },
  requests: {
    list: `${API_BASE_URL}/requests`,
    create: `${API_BASE_URL}/requests`,
    update: (id: string) => `${API_BASE_URL}/requests/${id}/status`,
    delete: (id: string) => `${API_BASE_URL}/requests/${id}`,
    bulkDelete: `${API_BASE_URL}/requests/bulk-delete`,
  },
  sites: {
    list: `${API_BASE_URL}/sites`,
    create: `${API_BASE_URL}/sites`,
    site: (id: string) => `${API_BASE_URL}/sites/${id}`,
    delete: (id: string) => `${API_BASE_URL}/sites/${id}`,
    bulkDelete: `${API_BASE_URL}/sites/bulk-delete`,
  },
  products: {
    list: `${API_BASE_URL}/products`,
    create: `${API_BASE_URL}/products`,
    product: (id: string) => `${API_BASE_URL}/products/${id}`,
    delete: (id: string) => `${API_BASE_URL}/products/${id}`,
    bulkDelete: `${API_BASE_URL}/products/bulk-delete`,
  },
  // Add more endpoint groups here as needed
  // Example:
  // suppliers: {
  //   list: `${API_BASE_URL}/suppliers`,
  //   create: `${API_BASE_URL}/suppliers`,
  //   update: (id: string) => `${API_BASE_URL}/suppliers/${id}`,
  //   delete: (id: string) => `${API_BASE_URL}/suppliers/${id}`,
  // },
} as const;
